import { ApiService } from '@/services/apiService';
import { CookiesStorageService } from '@/services/cookiesStorageService';
import { LocalStorageService } from '@/services/localStorageService';
import { COOKIES_KEYS, GOOGLE_ID, LOCAL_STORAGE_KEYS } from '@/constants';
import { getAnalyticsUserProperties } from './getAnalyticsUserProperties';
import { getUserDataFromLocalStorage } from './getUserDataFromLocalStorage';

type UniversalRecord = Record<string, unknown>;
interface UserAdData {
	adId: string;
	adName: string;
	adsetId: string;
	adsetName: string;
	campaignId: string;
	utmCampaign: string;
	utmSource: string;
	utmContent: string;
	utmTerm: string;
	adPlacement: string;
}

const splitUserAnalyticsData = (data: Record<string, unknown>) => {
	const userAdDataKeys = [
		'adId',
		'adName',
		'adsetId',
		'adsetName',
		'campaignId',
		'utmCampaign',
		'utmSource',
		'utmContent',
		'utmTerm',
		'adPlacement',
	];

	const userAdData: Partial<UserAdData> = {};
	const otherData: Record<string, unknown> = {};

	Object.entries(data).forEach(([key, value]) => {
		if (userAdDataKeys.includes(key)) {
			userAdData[key as keyof UserAdData] = value as string;
		} else {
			otherData[key] = value;
		}
	});

	return { userAdData, otherData };
};

interface DataType extends Record<string, string | UniversalRecord> {
	eventType: string;
	userAdData: Partial<UserAdData>;
}

export const sendAllUserDataToWeb = (
	eventType = '',
	property?: UniversalRecord,
) => {
	const userAnalyticsData = getAnalyticsUserProperties();
	const userData = getUserDataFromLocalStorage();
	const { userAdData, otherData } = splitUserAnalyticsData(userAnalyticsData);
	const data: DataType = {
		...userData,
		...otherData,
		...property,
		userAdData,
		eventType,
	};
	const clientId = CookiesStorageService.get(GOOGLE_ID.CLIENT_ID, '');
	if (clientId) {
		data['gaClientId'] = clientId;
	}

	if (!data['userId']) {
		const getUserId = LocalStorageService.get<string | undefined>(
			LOCAL_STORAGE_KEYS.USER_ID,
			undefined,
		);
		if (getUserId) {
			data['userId'] = getUserId;
		}
	}

	if (typeof window !== 'undefined') {
		data['url'] = window.location.href;
	}

	const uuid = CookiesStorageService.get<string>(COOKIES_KEYS.UUID, '');
	if (uuid) data['uuid'] = uuid;

	const gclid = CookiesStorageService.get<string>('gclid', '');
	if (gclid) data['gclid'] = gclid;

	const fbc = CookiesStorageService.get<string>('_fbc', '');
	if (fbc) data['fbc'] = fbc;

	const msclkid = CookiesStorageService.get(COOKIES_KEYS.UETMSCLKID, '');
	if (msclkid) data['msclkid'] = msclkid;

	const fbp = CookiesStorageService.get<string>('_fbp', '');
	if (fbp) data['fbp'] = fbp;

	ApiService.sendUserData(data)
		.then()
		.catch(error => {
			console.log('sendAllDataToWeb - ', error);
		});
};
